import moment from 'moment';

import { BOOK_DAY_LIMIT, DATE_DISPLAY_FORMAT, DATE_FORMAT } from 'utils/constants';

export const TODAY_MOMENT = moment();
export const BOOKING_LIMIT_MOMENT = moment().add(BOOK_DAY_LIMIT, 'day');

export const checkIsDate = (type, date1, date2, canOverlap) => {
  const date1Moment = moment(date1);
  const date2Moment = moment(date2);
  const typeInLowerCase = type.toLowerCase();

  const checkIsDateSame = () => date1Moment.isSame(date2Moment);
  const checkIsDateBefore = () => date1Moment.isBefore(date2Moment);
  const checkIsDateAfter = () => date1Moment.isAfter(date2Moment);

  switch (typeInLowerCase) {
    case 'same':
      return checkIsDateSame();

    case 'before':
      return checkIsDateBefore() || (canOverlap && checkIsDateSame());

    case 'after':
      return checkIsDateAfter() || (canOverlap && checkIsDateSame());

    default:
      return false;
  }
};
export const checkIsMoment = data => {
  return moment.isMoment(data);
};

export const checkIsDateInBetween = (currentDate, startDate, endDate, overlapStart, overlapEnd) => {
  return checkIsDate('after', currentDate, startDate, overlapStart) && checkIsDate('before', currentDate, endDate, overlapEnd);
};

export const calculateBookingNights = (startDate, endDate) => {
  return moment(endDate).diff(moment(startDate), 'day');
};

export const formatDateDisplay = (date, isDisplayDate) => {
  const dateFormat = isDisplayDate ? DATE_DISPLAY_FORMAT : DATE_FORMAT;

  return !!date ? moment(date).format(dateFormat) : date;
};

export const formatToMomentObject = date => {
  return !!date ? moment(date) : date;
};
